import formatCurrency from '@utils/format-currency'

/**
 * 住宿子訂單明細：每晚房價以外的列（後端 HotelOrderFrontResource 與後台同源）
 * extraGuestAdjustments、addons、customAdjustments、adjustments
 */

function formatAdjustmentLine(adj) {
  if (!adj) return null
  const amount = Number(adj.amount)
  const isNeg = amount < 0
  const title = adj.title || '調整'
  return {
    title,
    text: isNeg
      ? `- NT$ ${formatCurrency(Math.abs(amount))}`
      : `NT$ ${formatCurrency(amount)}`,
    class: isNeg ? 'text-danger' : '',
    textClass: 'font-number',
  }
}

/**
 * @param {object} item orders.items 單筆（hotel order）
 * @returns {Array<{ title: string, text: string, textClass?: string, class?: string }>}
 */
export function hotelOrderItemAdjustmentRows(item) {
  if (!item) return []

  const rows = []

  const extraGuest = item.extraGuestAdjustments || []
  extraGuest.forEach((ex) => {
    const parts = [ex.roomTypeTitle, ex.bookingDate].filter(Boolean)
    const sub = parts.length ? ` · ${parts.join(' · ')}` : ''
    rows.push({
      title: `寵物同住${sub}`,
      text: `NT$ ${formatCurrency(ex.price != null ? ex.price : 0)}`,
      textClass: 'font-number',
    })
  })

  const addons = item.addons || []
  addons.forEach((ad) => {
    rows.push({
      title: ad.goodsName || '加購',
      text: `NT$ ${formatCurrency(ad.lineTotal != null ? ad.lineTotal : 0)}`,
      textClass: 'font-number',
    })
  })

  ;(item.customAdjustments || []).forEach((adj) => {
    const line = formatAdjustmentLine(adj)
    if (line) rows.push(line)
  })

  ;(item.adjustments || []).forEach((adj) => {
    const line = formatAdjustmentLine(adj)
    if (line) rows.push(line)
  })

  return rows
}
